import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { maxLength, multiEmail } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

const fieldValidator = {
  mailing_email: [value => maxLength(value, 255), multiEmail],
  mailing_phone: [value => maxLength(value, 64)],
  mailing_address_line_1: [value => maxLength(value, 255)],
  mailing_address_line_2: [value => maxLength(value, 255)],
  mailing_city: [value => maxLength(value, 255)],
  mailing_state: [value => maxLength(value, 64)],
  mailing_zip_code: [value => maxLength(value, 32)]
};
class MailingAddressModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: props.entity[key] !== null ? props.entity[key] : '',
        visited: false,
        error: false
      };
    });

    this.state = { ...fields };
  }

  updateForm = (event, name) => {
    const inputData = {
      value: event.target.value,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] = formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.props.onSubmit(postData, null);
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Borrower Contact Information'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              {this.props.errorUnit && (
                <Alert color={'danger'}>{this.props.errorUnit}</Alert>
              )}
              <Row>
                <Col>
                  <LabelInput
                    name={'Email (Separate emails with a comma)'}
                    type={'text'}
                    {...this.state.mailing_email}
                    onChange={event => this.updateForm(event, 'mailing_email')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabelInput
                    name={'Phone'}
                    type={'text'}
                    {...this.state.mailing_phone}
                    onChange={event => this.updateForm(event, 'mailing_phone')}
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <LabelInput
                    name={'Address Line 1'}
                    type={'text'}
                    {...this.state.mailing_address_line_1}
                    onChange={event =>
                      this.updateForm(event, 'mailing_address_line_1')
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <LabelInput
                    name={'Address Line 2'}
                    type={'text'}
                    {...this.state.mailing_address_line_2}
                    onChange={event =>
                      this.updateForm(event, 'mailing_address_line_2')
                    }
                  />
                </Col>
              </Row>

              <Row>
                <Col>
                  <LabelInput
                    name={'City'}
                    type={'text'}
                    {...this.state.mailing_city}
                    onChange={event => this.updateForm(event, 'mailing_city')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'State'}
                    type={'text'}
                    {...this.state.mailing_state}
                    onChange={event => this.updateForm(event, 'mailing_state')}
                  />
                </Col>
                <Col>
                  <LabelInput
                    name={'Zip Code'}
                    type={'text'}
                    {...this.state.mailing_zip_code}
                    onChange={event =>
                      this.updateForm(event, 'mailing_zip_code')
                    }
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default MailingAddressModal;
